module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.1d9c7945.eot";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/fonts/OpenSans-Bold.eot
// module id = 22
// module chunks = 0